<div class="card__box__body">
  <div class="select-wrapper w-100">
    <select
        #interest
        id="legitimateInterest"
        [(ngModel)]="selectedValue"
        (change)="onSelectionChange($event)"
        class="dropdown is-lightblue"
        data-testid="legitimateInterest-selection"
    >
      <option disabled value="init">Welches berechtigte Interesse liegt vor?</option>
      <option value="owner">(1) Eigentümerpartei an Vertreter + DocEstate GmbH</option>
      <option value="authorized">(1) Eigentümerpartei an Vertreter und (2) Vertreter an DocEstate GmbH</option>
    </select>
  </div>
</div>
